import PlusSquare from './PlusSquare';

export default PlusSquare;
